import { render } from "./App.vue?vue&type=template&id=2ffa4f6e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2ffa4f6e&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/standart-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__